// Nodes sit on rows (top to bottom) and are spread evenly across their row; `accent` marks an output.

export const complianceLinter = {
  title: 'Compliance Linter',
  nodes: [
    { id: 'jobs', row: 0, label: 'Jobs API', sublabel: 'job settings · runs' },
    { id: 'compute', row: 0, label: 'Compute Metadata', sublabel: 'clusters · node types' },
    { id: 'catalog', row: 0, label: 'Unity Catalog', sublabel: 'schemas · tables' },
    { id: 'normalize', row: 1, label: 'Asset Normalizer', sublabel: 'typed asset records' },
    { id: 'rules', row: 2, label: 'Policy Rule Catalog', sublabel: 'version-controlled YAML' },
    { id: 'engine', row: 2, label: 'Rule Engine', sublabel: 'naming · tags · cost' },
    { id: 'verdict', row: 3, label: 'Verdict & Score', sublabel: 'severity-driven' },
    { id: 'history', row: 4, label: 'Scan History', sublabel: 'Delta tables' },
    { id: 'dashboard', row: 5, label: 'Compliance Dashboard', sublabel: 'by workspace · owner', accent: true },
  ],
  edges: [
    { from: 'jobs', to: 'normalize' },
    { from: 'compute', to: 'normalize' },
    { from: 'catalog', to: 'normalize' },
    { from: 'normalize', to: 'engine' },
    { from: 'rules', to: 'engine' },
    { from: 'engine', to: 'verdict' },
    { from: 'verdict', to: 'history' },
    { from: 'history', to: 'dashboard' },
  ],
};

export const observabilityPlatform = {
  title: 'Metadata Observability Platform',
  nodes: [
    { id: 'schedule', row: 0, label: 'Daily Schedule', sublabel: 'collect → publish' },
    { id: 'roster', row: 0, label: 'Workspace Roster', sublabel: 'one line per workspace' },
    { id: 'collector', row: 1, label: 'Parallel Collector', sublabel: 'one thread per workspace' },
    { id: 'ucrest', row: 2, label: 'Unity Catalog REST', sublabel: 'catalogs · schemas' },
    { id: 'infoschema', row: 2, label: 'information_schema', sublabel: 'object counts via SQL' },
    { id: 'jobsruns', row: 2, label: 'Jobs & Runs APIs', sublabel: 'fully paginated' },
    { id: 'results', row: 3, label: 'Results Store', sublabel: 'Delta · per-workspace writes' },
    { id: 'publish', row: 4, label: 'Publish Pipeline', sublabel: 'root causes · roll up' },
    { id: 'views', row: 5, label: 'Versioned SQL Views', sublabel: 'completion manifests' },
    { id: 'dashboard', row: 6, label: 'React Dashboard', sublabel: 'FastAPI backend', accent: true },
    { id: 'agent', row: 6, label: 'Genie AI Agent', sublabel: 'plain-English questions', accent: true },
  ],
  edges: [
    { from: 'schedule', to: 'collector' },
    { from: 'roster', to: 'collector' },
    { from: 'collector', to: 'ucrest' },
    { from: 'collector', to: 'infoschema' },
    { from: 'collector', to: 'jobsruns' },
    { from: 'ucrest', to: 'results' },
    { from: 'infoschema', to: 'results' },
    { from: 'jobsruns', to: 'results' },
    { from: 'results', to: 'publish' },
    { from: 'publish', to: 'views' },
    { from: 'views', to: 'dashboard' },
    { from: 'views', to: 'agent' },
  ],
};

export const microsoftArchitectures = [complianceLinter, observabilityPlatform];
